import React, { useEffect, useState } from "react";
import TextInput from "../../Global Functions/textInput";

const Sco = ({ onChange, propertyDataBackend }) => {
  const [propertyData, setPropertyData] = useState({
    total_quantity: "",
    no_of_bathroom: "",
    no_of_pantry: "",
    cover_parking: "",
    open_parking: "",
  });



  useEffect(() => {
    if (propertyDataBackend) {
      setPropertyData({
        total_quantity: propertyDataBackend.total_quantity || "",
        no_of_bathroom: propertyDataBackend.no_of_bathroom || "",
        no_of_pantry: propertyDataBackend.no_of_pantry || "",
        cover_parking: propertyDataBackend.cover_parking || "",
        open_parking: propertyDataBackend.open_parking || "",
      });
    }
  }, [propertyDataBackend]);

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    const updatedState = { ...propertyData, [name]: value };
    setPropertyData(updatedState);
    if (onChange) {
      onChange(updatedState);
    }
  };

  return (
    <div className="grid-span-2">
      <div className="grid-template-2 gap-10">
        <TextInput
          label="No. of Units"
          min={0}
          value={propertyData?.total_quantity || "N/A"}
          required
          type="number"
          name="total_quantity"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Open Parking"
          min={0}
          required
          value={propertyData?.open_parking || "N/A"}
          type="number"
          name="open_parking"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Cover Parking"
          min={0}
          value={propertyData?.cover_parking || "N/A"}
          required
          type="number"
          name="cover_parking"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Bathroom(s)"
          min={0}
          value={propertyData?.no_of_bathroom || "N/A"}
          required
          type="number"
          name="no_of_bathroom"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Pantry(s)"
          min={0}
          required
          value={propertyData?.no_of_pantry || "N/A"}
          type="number"
          name="no_of_pantry"
          onChange={handleAddChange}
        ></TextInput>
      </div>
    </div>
  );
};

export default Sco;
